module.exports = __webpack_public_path__ + "dingbeauty-build/img/time.07db64ce.svg";